export default __webpack_public_path__ + "images/QW.eb2546c.png";